import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Import, List, Menu, Settings } from "lucide-react";
import {
  useCreatePath,
  useGetResourceLabel,
  useResourceDefinitions,
  useTranslate,
} from "ra-core";
import { Link } from "react-router";
import { createElement } from "react";

const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  const [navOpen, setNavOpen] = useState(false);
  const translate = useTranslate();
  const createPath = useCreatePath();
  const getResourceLabel = useGetResourceLabel();
  const resources = useResourceDefinitions();

  // Resources to show in the hamburger menu (all list-able resources)
  const navResources = Object.keys(resources)
    .filter((name) => resources[name].hasList)
    .sort();

  return (
    <header className="fixed top-0 left-0 right-0 z-10 bg-secondary h-14 px-4 w-full flex justify-between items-center">
      {children}
      <Sheet open={navOpen} onOpenChange={setNavOpen}>
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            aria-label={translate("crm.navigation.label")}
          >
            <Menu className="size-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="w-64 p-0">
          <SheetHeader className="p-4 border-b">
            <SheetTitle>{translate("crm.navigation.label")}</SheetTitle>
          </SheetHeader>
          <nav className="flex flex-col p-2">
            {navResources.map((name) => {
              const to = createPath({ resource: name, type: "list" });
              const icon = resources[name].icon;
              return (
                <Button
                  key={name}
                  variant="ghost"
                  asChild
                  className="justify-start gap-3 h-11 px-3 text-sm font-normal"
                >
                  <Link to={to} onClick={() => setNavOpen(false)}>
                    {icon ? (
                      createElement(icon)
                    ) : (
                      <List className="size-5 text-muted-foreground" />
                    )}
                    {getResourceLabel(name, 2)}
                  </Link>
                </Button>
              );
            })}
            <div className="my-1 border-t" />
            <Button
              variant="ghost"
              asChild
              className="justify-start gap-3 h-11 px-3 text-sm font-normal"
            >
              <Link to="/import" onClick={() => setNavOpen(false)}>
                <Import className="size-5 text-muted-foreground" />
                {translate("crm.import.title", { _: "Import" })}
              </Link>
            </Button>
            <Button
              variant="ghost"
              asChild
              className="justify-start gap-3 h-11 px-3 text-sm font-normal"
            >
              <Link to="/settings" onClick={() => setNavOpen(false)}>
                <Settings className="size-5 text-muted-foreground" />
                {translate("crm.settings.title", { _: "Settings" })}
              </Link>
            </Button>
          </nav>
        </SheetContent>
      </Sheet>
    </header>
  );
};

export default MobileHeader;
